import { useCurrentAgreement, useCurrentUser, useRouteAuthorisation } from '@economic/react-app';
import { NavLinkProps } from 'react-router-dom';
import useAdminPreferences from '../../../shared/hooks/useAdminPreferences';
import { administrateAgreement } from '../../../shared/util/utilities/admin';

export const useHomeActionProps = (): Pick<NavLinkProps, 'to' | 'onClick'> => {
    const user = useCurrentUser();
    const agreement = useCurrentAgreement();
    const hasAccessToHome = useRouteAuthorisation('/home');
    const { defaultAdminPage } = useAdminPreferences();
    const isAdministratingAgreement = agreement.number !== user.agreement.number;

    let to = '/';
    let onClick;

    if (isAdministratingAgreement) {
        onClick = async event => {
            event.preventDefault();
            await administrateAgreement(
                user.id,
                null,
                false,
                false,
                user.agreement.number,
                () => {},
                () => {}
            );
        };
    } else if (user.isAdministrator) {
        to = `/admin/${defaultAdminPage}`;
    } else if (hasAccessToHome) {
        to = '/home';
    }

    return {
        to,
        onClick,
    };
};
